import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SignableDocumentsWithOutletIdUrl } from "../../../../../constants/apiUrls";
import appFetch from "../../../../../api/appFetch";
import { DisplayMessage } from "../../../../../services/helpers";

function useSignableDocumentsTableData(resources) {
  const [data, setData] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(0);
  const [previousSelectedOutlet, setPreviousSelectedOutlet] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const shouldRefresh = location.state?.refreshGrid || false;
      if (
        previousSelectedOutlet !== selectedOutlet ||
        shouldRefresh ||
        !data.length
      ) {
        setIsLoading(true);

        const url = SignableDocumentsWithOutletIdUrl(selectedOutlet);

        setPreviousSelectedOutlet(selectedOutlet);

        await appFetch({
          url: url,
          onSuccess: (response) => {
            const currentRows = [];

            if (response) {
              response
                .sort((el1, el2) => el1.id - el2.id)
                .forEach(function (rowData) {
                  currentRows.push({
                    outletDescription: rowData.outletDescription,
                    context: rowData.context,
                    countryId: rowData.countryId,
                    description: rowData.description,
                    id: rowData.id,
                    isAcceptanceMandatory: rowData.isAcceptanceMandatory,
                    isActive: rowData.isActive ? resources["Yes"] : resources["No"],
                    isB2CVisible: rowData.isB2CVisible,
                    isDefault: rowData.isDefault,
                    isDefaultAccepted: rowData.isDefaultAccepted,
                    isWarranty: rowData.isWarranty,
                    language: rowData.language,
                    outletId: rowData.outletId,
                  });
                });

              setData(currentRows);
            }

            if (shouldRefresh) {
              history.replace({
                pathname: location.pathname,
                state: {},
              });
            }
          },
          onError: (response) => {
            for (let i = 0; i < response.errors.length; i++) {
              DisplayMessage(response.errors[i], "error");
            }
          },
          onFinalize: () => {
            setIsLoading(false);
          },
        });
      }
    };

    fetchData();
  }, [selectedOutlet, location]);

  return {
    data,
    setData,
    isLoading,
    selectedOutlet,
    setSelectedOutlet,
  };
}

export default useSignableDocumentsTableData;
